// Shared recipes for floating panels (design spec §8.3 dropdown-menu, popover, command, select,
// combobox): one hairline, radius 10, --shadow-md, items 36 px (44 on coarse pointers).
//
// Portalled popups stack at --z-command, above dialogs (--z-dialog), so a select or menu opened
// inside a dialog is never hidden behind it; tooltips stay above everything.

export const POPUP_LAYER = "isolate z-command";

export const POPUP_PANEL =
  "rounded-[10px] border border-border bg-popover p-1 text-popover-foreground shadow-md outline-none duration-(--dur-base) ease-out data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-[side=bottom]:slide-in-from-top-1 data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 data-[side=top]:slide-in-from-bottom-1 data-[side=inline-end]:slide-in-from-left-1 data-[side=inline-start]:slide-in-from-right-1";

export const MENU_ITEM =
  "relative flex min-h-9 w-full cursor-default items-center gap-2 rounded-sm px-2.5 text-sm text-popover-foreground outline-hidden select-none pointer-coarse:min-h-11 focus:bg-muted data-highlighted:bg-muted data-disabled:pointer-events-none data-disabled:opacity-55 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4";

/** Section captions inside menus and the palette: DTP's 11 px / 600 / 1.2 px uppercase. */
export const MENU_CAPTION =
  "px-2.5 pt-2 pb-1 text-2xs font-semibold tracking-caps text-muted-foreground uppercase";

export const MENU_SEPARATOR = "-mx-1 my-1 h-px bg-border-subtle";
